import { InventoryService } from '../services'

const getDefaultState = () => {
    return {
        transaction: {},
        detail: [],
        newItem: newItem(),
        product: null,
        assignedLots: [],
        focusedRow: 0,
        error: null,
        page: 0,
        limit: 25,
        lastCountResult: 0,
        fetching: false,
        errorAnalysis: null,
    }
}

const newItem = () => {
    return {
        id:-1,
        crncy_decimal_position:0,
        is_inv:0,
        product_code:"",
        qty_decimal_position:0,
        reason_code:"",
        location_code:"",
        to_location_code:"",
        tran_qty:0,
        unit_cost:0,
        uofme_code:"",
        uofme_plan_code:"",
        tracking_option: 0,
        product_description: "",
        comment: "",
        Product: {
            uofme_plan_code: "",
            description: ""
        }
    }
}

const state = {...getDefaultState(), tran_type: null, postingStatus: false }

const actions = {
    resetState ({ commit }) {
        commit('resetState')
    },
    postTransaction({ dispatch, state,  commit }) {
        const id = state.transaction.id
        if (!id) return 

        dispatch('updateTransaction')
        commit('setPostingStatus', true)
        
        return InventoryService.postInventoryTransaction(id)
        .then(({data}) => {
            const intervalID = setInterval(() => {
                if (data && data.itemsValidations.length > 0 ) {
                    commit('setErrorAnalysis', {itemsValidations: data.itemsValidations})
                } else {
                    commit('setPostingStatus', false)
                }
                clearInterval(intervalID)
            }, 1000)
        })
        .catch(() => commit('setPostingStatus', false))
    },
    createTransaction({ commit }, tran_type) {
        InventoryService.transactionOpenMasterCreate(tran_type)
        .then(({ data, status }) => {
            if (status === 201) {
                commit('setTransaction', data)
            }
        })
    },
    fetchTransaction({ state, dispatch, commit }, [tranType, tranNumber]){
        commit('clearDetail')
        InventoryService.transactionOpenMasterGet(tranType, tranNumber)
        .then(({ data }) => commit('setTransaction', data))
        .then(() => {
            dispatch('fetchDetail', [tranType, tranNumber, state.page, state.limit])
            commit('INCREMENT_PAGE')
        })
    },
    fetchDetail({ state, commit }) {
        commit('setFetching', true)
        InventoryService.transactionOpenDetailGet(state.transaction.tran_type, state.transaction.tran_number, state.page, state.limit)
        .then(({ data }) => commit('addDetail', data))
        .finally(() => commit('setFetching', false))
    },
    updateTransaction({ state, commit}) {
        InventoryService.transactionOpenMasterEdit({
            tran_id: state.transaction.id,
            tran_date: state.transaction.tran_date,
            location_code: state.transaction.location_code,
            to_location_code: state.transaction.to_location_code,
            comment: state.transaction.comment,
        })
        .then(({ status }) => {
            if (status === 200) {
                commit('resetState')
            }
        })
    },
    fetchProduct({ state, commit }, product_code) {
        InventoryService.fetchProduct(product_code)
        .then(({ data }) => commit('setProduct', data ))
        .catch(e => commit('setError', e))
    },
    createDetail({ state, dispatch, commit }, product_code) {
        const id = state.transaction.id

        InventoryService.transactionOpenDetailCreate(id, product_code)
        .then(({ status = 0, data = null }) => {
            if (status === 201) {
                const { location_code = "", to_location_code="" } = state.transaction
                commit('setNewItem', {...data, location_code, to_location_code, isNew: true })
                commit('setFocusedRow')
            }
        })
        .catch(e => console.log('e',e))
    },
    updateNewItem({ state, commit }) {
        if (state.newItem.id < 0) return
        return InventoryService.transactionOpenDetailEdit(state.newItem)
        .then(({data, status}) => {
            if (status === 200) {
                commit('addItem', data)
                commit('resetNewItem')
                commit('setFocusedRow', data.id)
                commit('setProduct')
            }
            return status
        })
    },
    clearNewItem({ state, commit }) {
        const id = state.newItem.id

        const p = new Promise((res, rej) => {
            commit('resetNewItem')
            commit('setProduct')
            res()
        })

        if (id > 0) {
            InventoryService.transactionOpenDetailDelete(id)
            .then(({ status }) => {
                  if (status == 200) {
                      return p
                  }
                }
            );
        } else {
            return p
        }
        
    },
    updateDetail({ state, commit }, data) {
        return InventoryService.transactionOpenDetailEdit(data)
        .then(({data, status}) => {
            commit("updateDetail", data)
            return status
        })
    },
    updateCommentDetail({ state, commit }, comment) {
        InventoryService.transactionOpenDetailEdit({...state.focusedRow, comment })
        .then(({ data, status }) => commit("updateDetail", data))
    },  
    deleteDetail({ commit }, id) {
        InventoryService.transactionOpenDetailDelete(id)
        .then(({ status, data }) => {
              if (status == 200) {
                commit('removeItem', data.id)
              }
            }
          );
    },

    clearDetail({ commit }) {
        commit('createDetail')
    },
    fetchLotsItem({state, commit }) {
        const { tran_type, tran_number, line_seq } = state.focusedRow

        InventoryService.transactionOpenLotItemGetList(tran_type, tran_number, line_seq)
        .then(({data, status}) => {
          if (status === 200) {
            data.map(el=> el.expiration_date = moment(el.expiration_date).format("YYYY-MM-DD"))
            commit('setAssignedLots', data)
          }
        })
    },
    addLotNumber({state, commit}, lotData) {
        const { lot_number, expiration_date, lot_qty, bin_number } = lotData
        const id = state.focusedRow.id
        InventoryService.transactionOpenLotItemPost({id,lot_number, expiration_date, lot_qty, bin_number
        }).then(({ data, status }) => {
          if (status === 201) {
                data.expiration_date= moment(data.expiration_date, "YYYY-MM-DD")
                commit('addAssignedLot', data)
          }
        })
    },
    removeLotNumber({commit}, data) {
        InventoryService.transactionOpenLotItemDelete(data.id)
        .then(({ status, data }) => {
              if (status == 200) {
                commit('removeAssignedLot', data.id)
              }
            }
          );
    },
    assignLotNumber({state, dispatch, commit}, id_lot){
        InventoryService.transactionOpenLotAssign(state.focusedRow.id, id_lot)
        .then(({ data, status }) => {
          if (status === 201) {
            dispatch('inventory/fetchLotMaster', { 
                productCode: state.focusedRow.product_code, 
                locationCode: state.focusedRow.location_code
            }, { root: true })
            commit('addAssignedLot', data)
            
          }
        })
      },
    unassignLotNumber({state, dispatch, commit }, id) {
        InventoryService.transactionOpenLotItemDelete(id)
        .then(({ data, status }) => {
            if (status === 200) {
                commit('removeAssignedLot', data.id)
                dispatch('inventory/fetchLotMaster', { 
                    productCode: state.focusedRow.product_code, 
                    locationCode: state.focusedRow.location_code
                }, { root: true })
            }
        })
    },
}

const mutations = {
    resetState: (state) => (Object.assign(state, getDefaultState())),
    setError: (state, error) => state.error = error,
    setErrorAnalysis: (state, error) => state.errorAnalysis = error,
    setPostingStatus: (state, status) => state.postingStatus = status,
    setTransactionType: (state, tran_type) => state.tran_type = tran_type,
    setTransaction: (state, transaction) => {
        transaction.tran_date = moment(transaction.tran_date).format('YYYY-MM-DD')
        state.transaction = transaction
    },
    setProduct: (state, product) => {
        state.product = product 
        // if (product) {
        //     state.newItem.uofme_plan_code = product.uofme_plan_code
        //     state.newItem.product_description = product.description
        // }
    },
    addDetail: (state, detail) => { state.detail.push(...detail); state.lastCountResult=detail.length},
    updateDetail: (state, detail) => {
        let index = state.detail.findIndex(item => item.id === detail.id)
        state.detail[index].tran_qty = detail.tran_qty
        state.detail[index].location_code = detail.location_code
        state.detail[index].to_location_code = detail.to_location_code
        state.focusedRow = state.detail[index]
        
        
    },
    removeItem: (state, id) => state.detail = state.detail.filter(item => item.id !== id),
    clearDetail: (state) => {state.detail=[]; state.page = 0; },
    setFetching: (state, status) => (state.fetching = status),
    INCREMENT_PAGE: (state, page) => (state.page++),
    clearTransaction: (state) => (state.transaction = {}),
    updateTranDate: (state, value) => (state.transaction.tran_date = value),
    updateComment: (state, value) => (state.transaction.comment = value),
    updateLocation: (state, value) => (state.transaction.location_code = value),
    updateToLocation: (state, value) => (state.transaction.to_location_code = value),
    setNewItem: (state, item) => state.newItem = item,
    addItem: (state, newItem) => state.detail.push(newItem) ,
    resetNewItem: (state) => Object.assign(state.newItem, newItem()),
    updateNewItemProduct: (state, product_code) => state.newItem.product_code = product_code,
    updateNewItemUofmeCode: (state, uofme_code) => state.newItem.uofme_code = uofme_code,
    updateNewItemReasonCode: (state, reason_code) => state.newItem.reason_code = reason_code,
    updateNewItemTranQty: (state, tran_qty) => state.newItem.tran_qty = tran_qty,
    updateNewItemLocationCode: (state, location_code) => state.newItem.location_code = location_code,
    updateNewItemToLocationCode: (state, to_location_code) => state.newItem.to_location_code = to_location_code,
    updateNewItemUnitCost: (state, unit_cost) => state.newItem.unit_cost = unit_cost,
    setFocusedRow: (state, id) => {
        if (id > 0) {
            let idx = state.detail.findIndex(el => el.id === id)
            state.focusedRow = state.detail[idx]
        } else {
            state.focusedRow = state.newItem
        }
    },
    setAssignedLots: (state, data) => state.assignedLots = data,
    addAssignedLot: (state, data) => state.assignedLots.push(data),
    removeAssignedLot: (state, id) => state.assignedLots = state.assignedLots.filter(el => el.id !== id)
}

const getters = {
    tran_type: state => state.tran_type,
    transaction: state => state.transaction,
    detail: state => state.detail,
    newItem: state => state.newItem,
    itemById: state => id => {
        let index = state.detail.findIndex(item => item.id === id)
        
        return state.detail[index]
    },
    lastCountResult: state => state.lastCountResult,
    fetching: state => state.fetching,
    focusedRow: state => state.focusedRow,
    assignedLots: state => state.assignedLots,
    product: state => state.product ? state.product : {},
    error: state => state.error,
    errorAnalysis: state => state.errorAnalysis,
    postingStatus: state => state.postingStatus
}

export const ivTransaction = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};


// WEBPACK FOOTER //
// ./src/store/ivTransaction.js